import { render, staticRenderFns } from "./optins.vue?vue&type=template&id=20491e2d&scoped=true&"
import script from "./optins.vue?vue&type=script&lang=js&"
export * from "./optins.vue?vue&type=script&lang=js&"
import style0 from "./optins.vue?vue&type=style&index=0&id=20491e2d&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20491e2d",
  null
  
)

export default component.exports